import * as React from "react";

import { Input, Button } from "antd";
import { toast } from "react-toastify";

class UserPassword extends React.Component<{}, {}> {
	public render() {
		return (
			<div className="container-fluid">
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="currentPassword">Current password</label>
						<Input id="currentPassword" value="········" />
					</div>
				</div>
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="newPassword">New password</label>
						<Input id="newPassword" value="········" />
					</div>
				</div>
				<div className="form-group row">
					<div className="col-4">
						<label htmlFor="newPasswordConfirm">Confirm new password</label>
						<Input id="newPasswordConfirm" value="········" />
					</div>
				</div>
				<div className="form-group">
					<Button type="primary" onClick={this.onSave}>
						Save
					</Button>
				</div>
			</div>
		);
	}

	private onSave = () => {
		toast.info("This feature is coming soon.");
	};
}
export default UserPassword;
